import React from 'react';
import { ResponsiveEmbed } from 'react-bootstrap';

import { useParams } from 'react-router-dom';

const TradingView = () => {
  const { code:stockCode } = useParams();
  const code = stockCode?.toUpperCase();

  const { TRADING_VIEW } = process.env;

  return (
    <div style={{ width: '100%', height: 'auto' }}>
      <ResponsiveEmbed aspectRatio="4by3" style={{ height: 'calc(100vh - 95px)' }}>
        <embed type="" src={`${TRADING_VIEW}/?ticker=${code}`} />
      </ResponsiveEmbed>
    </div>
  );
};

export default TradingView;
